import React, { Component } from 'react'
import './ToggleFilter.css'

let _id_counter = 1

class ToggleFilter extends Component {
  constructor(props) {
    super(props)

    this.input_id = `toggle-${_id_counter++}`
  }

  render() {
    let { label, value, onChange } = this.props
    let { input_id } = this
    return (
      <div className="ToggleFilter">
        <input
          id={input_id}
          type="checkbox"
          checked={!!value}
          onChange={(ev) => onChange(ev.target.checked)}
        />
        <label htmlFor={input_id}>{label}</label>
      </div>
    )
  }
}

export default ToggleFilter



// WEBPACK FOOTER //
// ./src/filters/ToggleFilter.js